module.exports = { validMongoId: /^[a-f\d]{24}$/i }
